import axios from 'axios'
import { get7RBaseURL } from 'network/api/networkSettings'
import qs from 'qs'

export const revokeTokenUtility = (revokeTokenURL, request) => {
    const config = {
        method: 'post',
        maxBodyLength: Infinity,
        url: `${get7RBaseURL()}/auth${revokeTokenURL}`,
        headers: {
            'content-type': 'application/x-www-form-urlencoded',
        },
        data: qs.stringify(request),
    }

    axios
        .request(config)
        .then(() => {
            console.log('Successfully token revoked')
        })
        .catch(error => {
            console.log(error)
        })
}
